import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { EventsService, GetMeStatusResponseDto } from '@app/client';
import { BlockingStartupModalComponent } from '@app/features/appointments/components/blocking-startup-modal/blocking-startup-modal.component';
import { DialogService } from 'primeng/dynamicdialog';
import { first, Observable, switchMap, tap } from 'rxjs';
import { AuthServices } from '../services/auth.services';

@Injectable({
  providedIn: 'root',
})
export class UserStatusGuard implements CanActivate {
  dialog = inject(DialogService);
  authService = inject(AuthServices);

  meStatus: GetMeStatusResponseDto = {
    events: [],
    outcomes: false,
    status: '',
  };

  constructor(private router: Router, private eventsService: EventsService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.eventsService.getMeStatus().pipe(
      tap((meStatus) => (this.meStatus = meStatus)),
      switchMap(() => this.authService.user().pipe(first((user) => user !== null))),
      tap((user) => {
        if (this.meStatus.events.length > 0) {
          return this.dialog.open(BlockingStartupModalComponent, {
            closable: false,
            data: {
              user,
              events: this.meStatus.events,
            },
          });
        } else {
          return true
        }
      }),
    );
  }
}
